import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/lib/i18n";

const LanguageContext = createContext(null);
const STORAGE_KEY = "immomaxe_lang";

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "fr";
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) return saved;
    const nav = ((navigator.language || navigator.userLanguage) || "fr").toLowerCase();
    return nav.startsWith("en") ? "en" : "fr";
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (l) => setLangState(l);
  const toggleLang = () => setLangState((l) => (l === "fr" ? "en" : "fr"));

  const t = (path) => {
    const dict = translations[lang] || translations.fr;
    const val = path.split(".").reduce((o, k) => (o && o[k] != null ? o[k] : undefined), dict);
    if (val !== undefined) return val;
    const fallback = path.split(".").reduce((o, k) => (o && o[k] != null ? o[k] : undefined), translations.fr);
    return fallback !== undefined ? fallback : path;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) return { lang: "fr", setLang: () => {}, toggleLang: () => {}, t: (p) => p };
  return ctx;
};
